"use client";

import formatDate from "@/util/formatDate";
// import queryMutation from "./query-mutation";

const hcpDirectoryInquiryQuery = ({
  interaction_type,
  first_name,
  last_name,
  email,
  primary_specialty,
  npi_id,
  phone_number,
  facility_name,
  address_line_1,
  address_line_2,
  city,
  state,
  zip,
  crnhcp_treat_cah_flag,
  number_of_patients,
  hcp_authored_publications_flag,
  hcp_participated_clinical_trials_flag,
  hcp_practice_comprehensive_center_flag
}) => {
  // Slalom API query for the HCP signup form
  const date = formatDate();
  const mutationVariables = {
    interaction_type,
    first_name,
    last_name,
    email_address: email,
    npi_id,

    primary_specialty: primary_specialty ? primary_specialty : undefined,
    created_datetime: date,
    postal_code: zip ? zip : undefined,
    work_phone: phone_number ? '1' + phone_number?.replace(/[^0-9]/g, '') : undefined,
    facility_name: facility_name ? facility_name : undefined,
    address_line_1: address_line_1 ? address_line_1 : undefined,
    address_line_2: address_line_2 ? address_line_2 : undefined,
    city: city ? city : undefined,
    state: state ? state : undefined,
    crnhcp_treat_cah_flag: crnhcp_treat_cah_flag ? 'True' : 'False',
    number_of_patients: number_of_patients === null || !crnhcp_treat_cah_flag ? undefined : number_of_patients,
    hcp_authored_publications_flag : hcp_authored_publications_flag ? 'True' : 'False',
    hcp_participated_clinical_trials_flag: hcp_participated_clinical_trials_flag ? 'True' : 'False',
    hcp_practice_comprehensive_center_flag: hcp_practice_comprehensive_center_flag ? 'True' : 'False',

    country_code: "US",
    contact_type: "HCP",
    source_name: "StudioRx",
    source_record_id: Date.now().toString(36) + Math.random().toString(36).substring(2, 12).padStart(12, '0'),
    business_unit: "Crenessity_HCP",
    indication: "CAH",
    is_branded_flag: "True",
    language: "English",
    opt_source: "Crenessity.com-Doctor_Directory"
  }
  
  return mutationVariables;
};

export default hcpDirectoryInquiryQuery;